// @flow
import type { ProductPurchasability } from "../../types/publicpurchasable";

const convertToMap = (
  purchasability: ?any
): Map<number, ProductPurchasability> => {
  purchasability = purchasability || {};
  const output: Map<number, ProductPurchasability> = new Map();
  Object.entries(purchasability).forEach(([key, value]) => {
    var purchasabilityValue: ProductPurchasability;
    if (value === "IN_STORE_ONLY") {
      purchasabilityValue = "IN_STORE_ONLY";
    } else if (value === "Check Availability (Creative Glass)") {
      purchasabilityValue = "Check Availability (Creative Glass)";
    } else if (value === "Add") {
      purchasabilityValue = "Add";
    } else if (value === "Enquire") {
      purchasabilityValue = "Enquire";
    } else {
      purchasabilityValue = "Shop in maX";
    }
    output.set(parseInt(key), purchasabilityValue);
  });
  return output;
};

export async function fetchPublicPurchasableData(
  productIds: number[]
): Promise<Map<number, ProductPurchasability>> {
  const data = await (await window.fetch(
    `/wishlist/public/product/purchasability?productCodes=${productIds.join(
      ","
    )}`
  )).json();

  return convertToMap(data);
}
